import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import theme from "theme";

// Icons
import { ReactComponent as Arrow } from "assets/down-arrow.svg";

// Material UI components
import {
  Select as SelectMUI,
  FormControl,
  InputLabel,
  FormHelperText,
  MenuItem,
} from "@material-ui/core";
import { WHITE } from "constants/colors";

const useStyles = makeStyles(() => ({
  select: ({ themeType }) => ({
    backgroundColor:
      themeType === "dark"
        ? theme.palette.componentsBackground.main
        : theme.palette.componentsBackground.light,
    color:
      themeType === "dark"
        ? theme.palette.componentsBackground.light
        : theme.palette.common.black,
  }),
  menuItem: ({ themeType }) => ({
    color:
      themeType === "dark"
        ? theme.palette.componentsBackground.main
        : theme.palette.common.black,
  }),
  label: ({ themeType }) => ({
    color:
      themeType === "dark" ? WHITE : theme.palette.componentsBackground.main,
    "&.Mui-focused": {
      color:
        themeType === "dark" ? WHITE : theme.palette.componentsBackground.main,
    },
  }),
  icon: {
    width: 16,
    height: "auto",
    marginRight: theme.spacing(1),
    cursor: "pointer",
  },
}));

const Select = forwardRef(
  (
    { themeType, label, data, helperText, required, showEmpty, ...other },
    ref
  ) => {
    const classes = useStyles({ themeType });

    return (
      <FormControl fullWidth variant="outlined" required={required}>
        <InputLabel className={classes.label}>{label}</InputLabel>
        <SelectMUI
          {...other}
          className={classes.select}
          inputProps={{ inputRef: ref }}
          IconComponent={() => <Arrow className={classes.icon} />}
          label={label}
        >
          {showEmpty && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {data?.map((item, index) => (
            <MenuItem
              className={classes.menuItem}
              key={index}
              value={item.value}
            >
              <em>{item.name}</em>
            </MenuItem>
          ))}
        </SelectMUI>
        {other.error && <FormHelperText error>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

Select.displayName = "Select";

Select.propTypes = {
  data: PropTypes.array,
  helperText: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  themeType: PropTypes.string,
  showEmpty: PropTypes.bool,
};

Select.defaultProps = {
  data: [],
  helperText: "Campo obbligatorio",
  required: false,
  themeType: "dark",
  showEmpty: false,
};

export default Select;
